export default __webpack_public_path__ + "static/media/nt-intro1.ff43a63c.jpg";